// @ts-nocheck
import { useState, createContext } from 'react';
import { api } from '@/utils/api';
import { useEventListener } from '@/hooks';

const defaultContext = {
  loaded: false,
  loading: false,
  types: api.consent.consentTypes || [],
};

export const ConsentTypesContext = createContext(defaultContext);

export function useConsentTypesContext() {
  const [context, setContext] = useState(defaultContext);

  useEventListener(api.consent.events.ConsentTypesLoading, () =>
    setContext({ ...context, loading: true }),
  );
  useEventListener(api.consent.events.ConsentTypesLoaded, () =>
    setContext({ ...context, loaded: true, loading: false }),
  );
  useEventListener(api.consent.events.ConsentTypesChanged, () =>
    setContext({ ...context, events: api.consent.consentTypes }),
  );

  return {
    ...context,
  };
}
